// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"149":"d2389679","399":"bb7c55b6","438":"17980f7c","453":"dcfc9013","640":"0762d4e8","701":"c65df8ca"}[chunkId] + ".chunk.js";
};